import { render, staticRenderFns } from "./ProductCreatedSuccess.vue?vue&type=template&id=954e109e"
import script from "./ProductCreatedSuccess.vue?vue&type=script&lang=js"
export * from "./ProductCreatedSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports